import { Box } from '@mui/material';
import { motion } from 'framer-motion';
import { useEffect, useRef, useState } from 'react';
import Main from './variants/agent/Main';
import Agent from './Agent';
import Admin from './Admin';
import Client from './Client';

const sidebarVariants = {
  hidden: { opacity: 0, scale: 0.95, transition: { duration: 0.1 } },
  visible: { opacity: 1, scale: 1, transition: { duration: 0.1 } },
};

const AccountSidebar = ({
  open,
  userId,
  userRole,
  toggleSidebar,
}: {
  open: boolean;
  userId: string;
  userRole: string;
  toggleSidebar: () => void;
}) => {
  const sidebarRef = useRef<HTMLDivElement | null>(null);

  const [isClosing, setIsClosing] = useState(false);
  const [isDialogOpen, setIsDialogOpen] = useState(false);

  const handleDialogStateChange = (isOpen: boolean) => {
    setIsDialogOpen(isOpen);
  };

  useEffect(() => {
    const handleClickOutside = (event: MouseEvent) => {
      if (
        sidebarRef.current &&
        !sidebarRef.current.contains(event.target as Node) &&
        !isDialogOpen
      ) {
        toggleSidebar();
      }
    };

    if (open) {
      document.addEventListener('mousedown', handleClickOutside);
    }

    return () => {
      document.removeEventListener('mousedown', handleClickOutside);
    };
  }, [open, isDialogOpen]);

  return (
    <motion.div
      ref={sidebarRef}
      initial="hidden"
      animate={open && !isClosing ? 'visible' : 'hidden'}
      exit="hidden"
      variants={sidebarVariants}
      style={{
        width: '430px',
        height: '100vh',
        position: 'fixed',
        top: 0,
        right: 140,
        backgroundColor: '#E7ECF2',
        zIndex: 900,
        willChange: 'transform',
        boxShadow: '0px 0px 74.57px 0px #00000040',
        overflow: 'hidden',
        pointerEvents: open ? 'auto' : 'none',
      }}
    >
      <Box sx={{ position: 'relative', height: '100%', width: '100%' }}>
        <img
          alt="coinsEmptyState"
          src="/assets/background/coinsEmptyState.svg"
          style={{
            position: 'absolute',
            top: 290,
            left: -190,
            width: '448px',
            height: '550px',
            opacity: '25%',
            zIndex: 1,
            objectFit: 'cover',
            pointerEvents: 'none',
          }}
        />
        <Box
          sx={{
            width: '100%',
            height: '100%',
            pt: '100px',
            pb: '20px',
            px: '55px',
            display: 'flex',
            flexDirection: 'column',
            gap: '48px',
            overflowY: 'auto',
            boxSizing: 'border-box',
            position: 'relative',
            zIndex: 2,
          }}
        >
          {userRole === 'admin' && <Admin />}
          {userRole === 'agent' && <Agent userId={userId} />}
          {userRole === 'client' && <Client userId={userId} onDialogStateChange={handleDialogStateChange} />}
        </Box>
      </Box>
    </motion.div>
  );
};

export default AccountSidebar;
